import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const banHangMenu: NavMenu = {
  title: 'Bán hàng',
  items: [
    {
      title: 'Đơn hàng',
      items: [
        {
          title: 'Đơn hàng',
          icon: <AritoIcon icon={770} />,
          href: '/ban-hang/don-hang/don-hang'
        },
        {
          title: 'Duyệt đơn hàng',
          icon: <AritoIcon icon={770} />,
          href: '/ban-hang/don-hang/duyet-don-hang'
        }
      ]
    },
    {
      title: 'Hóa đơn bán ra',
      items: [
        {
          title: 'Hóa đơn bán hàng',
          icon: <AritoIcon icon={770} />,
          href: '/ban-hang/hoa-don-ban-ra/hoa-don-ban-hang',
          group: 0
        },
        {
          title: 'Hóa đơn bán dịch vụ',
          icon: <AritoIcon icon={780} />,
          href: '/ban-hang/hoa-don-ban-ra/hoa-don-ban-dich-vu',
          group: 0
        }
      ]
    },
    {
      title: 'Hóa đơn điều chỉnh/Trả lại',
      items: [
        {
          title: 'Hóa đơn điều chỉnh giá hàng bán',
          icon: <AritoIcon icon={767} />,
          href: '/ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dieu-chinh-gia-hang-ban'
        },
        {
          title: 'Phiếu nhập hàng bán trả lại',
          icon: <AritoIcon icon={766} />,
          href: '/ban-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-hang-ban-tra-lai'
        },
        {
          title: 'Hóa đơn dịch vụ trả lại, giảm giá',
          icon: <AritoIcon icon={766} />,
          href: '/ban-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-giam-gia'
        }
      ]
    },
    {
      title: 'Phân bổ thu tiền cho các hoá đơn',
      icon: <AritoIcon icon={625} />,
      href: '/ban-hang/phan-bo-thu-tien-cho-cac-hoa-don'
    },
    {
      title: 'Tất toán hoá đơn',
      icon: <AritoIcon icon={73} />,
      href: '/ban-hang/tat-toan-hoa-don'
    },
    {
      title: 'Cập nhật điều kiện thanh toán',
      icon: <AritoIcon icon={284} />,
      href: '/ban-hang/cap-nhat-dieu-kien-thanh-toan'
    },
    {
      title: 'Tính lại số dư tức thời theo tài khoản',
      icon: <AritoIcon icon={171} />,
      href: '/ban-hang/tinh-lai-so-du-tuc-thoi-theo-tai-khoan'
    },
    {
      title: 'Điều chỉnh cấn trừ công nợ',
      icon: <AritoIcon icon={766} />,
      items: [
        {
          title: 'Chứng từ phải thu khác, chứng từ bù trừ công nợ',
          icon: <AritoIcon icon={845} />,
          href: '/ban-hang/dieu-chinh-can-tru-cong-no/chung-tu-phai-thu-khac-chung-tu-bu-tru-cong-no'
        },
        {
          title: 'Bút toán điều chỉnh giảm công nợ',
          icon: <AritoIcon icon={844} />,
          href: '/ban-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no'
        }
      ]
    },
    {
      title: 'Báo cáo bán hàng',
      icon: <AritoIcon icon={828} />,
      items: [
        {
          title: 'Báo cáo tình trạng đơn hàng',
          icon: <AritoIcon icon={192} />,
          href: '/ban-hang/bao-cao-ban-hang/bao-cao-tinh-trang-don-hang'
        },
        {
          title: 'Bảng kê hóa đơn bán hàng, dịch vụ',
          icon: <AritoIcon icon={860} />,
          href: '/ban-hang/bao-cao-ban-hang/bang-ke-hoa-don-ban-hang-dich-vu'
        },
        {
          title: 'Bảng tổng hợp hóa đơn bán hàng hàng hóa, dịch vụ',
          icon: <AritoIcon icon={860} />,
          href: '/ban-hang/bao-cao-ban-hang/bang-tong-hop-hoa-don-ban-hang-hoa-dich-vu'
        },
        {
          title: 'Bảng kê hàng bán bị trả lại',
          icon: <AritoIcon icon={235} />,
          href: '/ban-hang/bao-cao-ban-hang/bang-ke-hang-ban-bi-tra-lai'
        },
        {
          title: 'Báo cáo tổng hợp bán hàng thuần',
          href: '/ban-hang/bao-cao-ban-hang/bao-cao-tong-hop-ban-hang-thuan'
        },
        {
          title: 'Báo cáo tổng hợp hàng bán trả lại',
          href: '/ban-hang/bao-cao-ban-hang/bao-cao-tong-hop-hang-ban-tra-lai'
        },
        {
          title: 'Báo cáo so sánh bán hàng hai kỳ',
          href: '/ban-hang/bao-cao-ban-hang/bao-cao-so-sanh-ban-hang-hai-ky'
        },
        {
          title: 'Báo cáo bán hàng nhiều kỳ',
          icon: <AritoIcon icon={230} />,
          href: '/ban-hang/bao-cao-ban-hang/bao-cao-ban-hang-nhieu-ky'
        },
        {
          title: 'Báo cáo bán hàng nhóm theo 2 chỉ tiêu',
          icon: <AritoIcon icon={199} />,
          href: '/ban-hang/bao-cao-ban-hang/bao-cao-ban-hang-nhom-theo-2-chi-tieu'
        }
      ]
    },
    {
      title: 'Công nợ khách hàng',
      icon: <AritoIcon icon={828} />,
      items: [
        {
          title: 'Sổ chi tiết công nợ theo khách hàng',
          icon: <AritoIcon icon={860} />,
          href: '/ban-hang/cong-no-khach-hang/so-chi-tiet-cong-no-theo-khach-hang'
        },
        {
          title: 'Bảng cân đối phát sinh công nợ',
          icon: <AritoIcon icon={374} />,
          href: '/ban-hang/cong-no-khach-hang/bang-can-doi-phat-sinh-cong-no'
        },
        {
          title: 'Báo cáo số dư công nợ',
          icon: <AritoIcon icon={35} />,
          href: '/ban-hang/cong-no-khach-hang/bao-cao-so-du-cong-no'
        },
        {
          title: 'Báo cáo đối chiếu công nợ',
          icon: <AritoIcon icon={868} />,
          href: '/ban-hang/cong-no-khach-hang/so-doi-chieu-cong-no'
        },
        {
          title: 'Bảng xác nhận công nợ',
          icon: <AritoIcon icon={236} />,
          href: '/ban-hang/cong-no-khach-hang/bang-xac-nhan-cong-no'
        },
        {
          title: 'Sổ chi tiết công nợ nhiều khách hàng',
          icon: <AritoIcon icon={137} />,
          href: '/ban-hang/cong-no-khach-hang/so-chi-tiet-cong-no-nhieu-khach-hang'
        }
      ]
    },
    {
      title: 'Công nợ hóa đơn bán',
      icon: <AritoIcon icon={769} />,
      items: [
        {
          title: 'Bảng kê công nợ theo hóa đơn',
          icon: <AritoIcon icon={764} />,
          href: '/ban-hang/cong-no-hoa-don-ban/bang-ke-cong-no-theo-hoa-don'
        },
        {
          title: 'Bảng kê chi tiết thu tiền theo hoá đơn',
          icon: <AritoIcon icon={776} />,
          href: '/ban-hang/cong-no-hoa-don-ban/bang-ke-chi-tiet-thu-tien-theo-hoa-don'
        },
        {
          title: 'Báo cáo công nợ theo hoá đơn có CLTG',
          icon: <AritoIcon icon={779} />,
          href: '/ban-hang/cong-no-hoa-don-ban/bao-cao-cong-no-theo-hoa-don-co-cltg'
        }
      ]
    },
    {
      title: 'Hóa đơn điện tử',
      icon: <AritoIcon icon={769} />,
      items: [
        {
          title: 'Kiểm tra tình trạng hóa đơn điện tử',
          icon: <AritoIcon icon={769} />,
          href: '/ban-hang/hoa-don-dien-tu/kiem-tra-tinh-trang-hoa-don-dien-tu'
        },
        {
          title: 'Điều chỉnh thông tin hóa đơn đã xác thực',
          icon: <AritoIcon icon={769} />,
          href: '/ban-hang/hoa-don-dien-tu/dieu-chinh-thong-tin-hoa-don-da-xac-thuc'
        },
        {
          title: 'Khởi tạo xác thực và thay thế hóa đơn điện tử',
          icon: <AritoIcon icon={769} />,
          href: '/ban-hang/hoa-don-dien-tu/khoi-tao-xac-thuc-va-thay-the-hoa-don-dien-tu'
        }
      ]
    }
  ]
};
